<template>
  <div class="yyds">
      <div class="user-nav-box">
          <MessageBox />
      </div>
      <div class="user-conent-box">
          <ConentBox />
      </div>
      <div class="user-extension-box">
          <ExtensionBox />
      </div>
  </div>
</template>
<script>
import messagebox from  "@/components/user/tohome/messagebox"
import conentbox from  "@/components/user/tohome/conentbox"
import extensionbox from  "@/components/user/tohome/extensionbox"
export default {
  name: "user",
  data() {
    return {};
  },
  components: {
      MessageBox:messagebox,
      ConentBox:conentbox,
      ExtensionBox:extensionbox
  },
  mounted() {},

  methods: {},

  watch: {},
};
</script>

<style lang="less" scoped>
.yyds {
  display: flex;
  flex-wrap: wrap;
//   flex-direction: row-reverse;
  justify-content: space-between;
  min-height: 800px;
  background-color: aquamarine;
  padding: 10px;
  .user-nav-box{
   width: 300px;
   background-color: bisque;
  }
  .user-conent-box{
         width:590px;
   background-color: rgb(155, 99, 31);

  }
  .user-extension-box{
         width: 330px;
   background-color: rgb(129, 238, 143);

  }
}
</style>


// WEBPACK FOOTER //
// src/components/user/tohome/yyds.vue